export const DEFAULT_LOGO_SRC = "../assets/img/medicity_logo.png";
export const DEFAULT_APP_LOGO_SRC = "../assets/img/logo.png";

export const getBase64ImageType = (base64 = "") => {
  if (base64.startsWith("iVBOR")) return "png";
  if (base64.startsWith("/9j/")) return "jpeg";
  if (base64.startsWith("R0lGOD")) return "gif";
  if (base64.startsWith("UklGR")) return "webp";
  return "png";
};

export const getBase64ImageSrc = (base64) => {
  if (!base64) return "";
  if (base64.startsWith("data:image/")) return base64;

  return `data:image/${getBase64ImageType(base64)};base64,${base64}`;
};
